/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BatchDeletePackageTemplateRequest,
    BatchDeletePackageTemplateResponse,
    CreatePackageTemplateRequest,
    GetPackageTemplateResponse,
    GetPackageTemplateUnitResponse,
    IdResponse,
    PatchPackageTemplateRequest,
    PatchPackageTemplateUnitRequest,
} from '../models';

export interface GlobalPackageTemplateApiControllerBatchDeleteRequest {
    batchDeletePackageTemplateRequest: BatchDeletePackageTemplateRequest;
}

export interface GlobalPackageTemplateApiControllerCreateRequest {
    createPackageTemplateRequest: CreatePackageTemplateRequest;
}

export interface GlobalPackageTemplateApiControllerDeleteRequest {
    packageTemplateId: string;
}

export interface GlobalPackageTemplateApiControllerPatchRequest {
    packageTemplateId: string;
    patchPackageTemplateRequest: PatchPackageTemplateRequest;
}

export interface GlobalPackageTemplateApiControllerPatchPackageTemplateUnitRequest {
    patchPackageTemplateUnitRequest: PatchPackageTemplateUnitRequest;
}

/**
 * 
 */
export class GlobalPackageTemplateApi extends runtime.BaseAPI {

    /**
     */
    async globalPackageTemplateApiControllerBatchDeleteRaw(requestParameters: GlobalPackageTemplateApiControllerBatchDeleteRequest): Promise<runtime.ApiResponse<BatchDeletePackageTemplateResponse>> {
        if (requestParameters.batchDeletePackageTemplateRequest === null || requestParameters.batchDeletePackageTemplateRequest === undefined) {
            throw new runtime.RequiredError('batchDeletePackageTemplateRequest','Required parameter requestParameters.batchDeletePackageTemplateRequest was null or undefined when calling globalPackageTemplateApiControllerBatchDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/global-package-templates:batchDelete`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.batchDeletePackageTemplateRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async globalPackageTemplateApiControllerBatchDelete(requestParameters: GlobalPackageTemplateApiControllerBatchDeleteRequest): Promise<BatchDeletePackageTemplateResponse> {
        const response = await this.globalPackageTemplateApiControllerBatchDeleteRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async globalPackageTemplateApiControllerCreateRaw(requestParameters: GlobalPackageTemplateApiControllerCreateRequest): Promise<runtime.ApiResponse<IdResponse>> {
        if (requestParameters.createPackageTemplateRequest === null || requestParameters.createPackageTemplateRequest === undefined) {
            throw new runtime.RequiredError('createPackageTemplateRequest','Required parameter requestParameters.createPackageTemplateRequest was null or undefined when calling globalPackageTemplateApiControllerCreate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/global-package-templates`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createPackageTemplateRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async globalPackageTemplateApiControllerCreate(requestParameters: GlobalPackageTemplateApiControllerCreateRequest): Promise<IdResponse> {
        const response = await this.globalPackageTemplateApiControllerCreateRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async globalPackageTemplateApiControllerDeleteRaw(requestParameters: GlobalPackageTemplateApiControllerDeleteRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.packageTemplateId === null || requestParameters.packageTemplateId === undefined) {
            throw new runtime.RequiredError('packageTemplateId','Required parameter requestParameters.packageTemplateId was null or undefined when calling globalPackageTemplateApiControllerDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/global-package-templates/{packageTemplateId}`.replace(`{${"packageTemplateId"}}`, encodeURIComponent(String(requestParameters.packageTemplateId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async globalPackageTemplateApiControllerDelete(requestParameters: GlobalPackageTemplateApiControllerDeleteRequest): Promise<void> {
        await this.globalPackageTemplateApiControllerDeleteRaw(requestParameters);
    }

    /**
     */
    async globalPackageTemplateApiControllerGetRaw(): Promise<runtime.ApiResponse<Array<GetPackageTemplateResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/global-package-templates`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async globalPackageTemplateApiControllerGet(): Promise<Array<GetPackageTemplateResponse>> {
        const response = await this.globalPackageTemplateApiControllerGetRaw();
        return await response.value();
    }

    /**
     */
    async globalPackageTemplateApiControllerGetPackageTemplateUnitRaw(): Promise<runtime.ApiResponse<GetPackageTemplateUnitResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/global-package-template-unit`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async globalPackageTemplateApiControllerGetPackageTemplateUnit(): Promise<GetPackageTemplateUnitResponse> {
        const response = await this.globalPackageTemplateApiControllerGetPackageTemplateUnitRaw();
        return await response.value();
    }

    /**
     */
    async globalPackageTemplateApiControllerPatchRaw(requestParameters: GlobalPackageTemplateApiControllerPatchRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.packageTemplateId === null || requestParameters.packageTemplateId === undefined) {
            throw new runtime.RequiredError('packageTemplateId','Required parameter requestParameters.packageTemplateId was null or undefined when calling globalPackageTemplateApiControllerPatch.');
        }

        if (requestParameters.patchPackageTemplateRequest === null || requestParameters.patchPackageTemplateRequest === undefined) {
            throw new runtime.RequiredError('patchPackageTemplateRequest','Required parameter requestParameters.patchPackageTemplateRequest was null or undefined when calling globalPackageTemplateApiControllerPatch.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/global-package-templates/{packageTemplateId}`.replace(`{${"packageTemplateId"}}`, encodeURIComponent(String(requestParameters.packageTemplateId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.patchPackageTemplateRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async globalPackageTemplateApiControllerPatch(requestParameters: GlobalPackageTemplateApiControllerPatchRequest): Promise<void> {
        await this.globalPackageTemplateApiControllerPatchRaw(requestParameters);
    }

    /**
     */
    async globalPackageTemplateApiControllerPatchPackageTemplateUnitRaw(requestParameters: GlobalPackageTemplateApiControllerPatchPackageTemplateUnitRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.patchPackageTemplateUnitRequest === null || requestParameters.patchPackageTemplateUnitRequest === undefined) {
            throw new runtime.RequiredError('patchPackageTemplateUnitRequest','Required parameter requestParameters.patchPackageTemplateUnitRequest was null or undefined when calling globalPackageTemplateApiControllerPatchPackageTemplateUnit.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/global-package-template-unit`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.patchPackageTemplateUnitRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async globalPackageTemplateApiControllerPatchPackageTemplateUnit(requestParameters: GlobalPackageTemplateApiControllerPatchPackageTemplateUnitRequest): Promise<void> {
        await this.globalPackageTemplateApiControllerPatchPackageTemplateUnitRaw(requestParameters);
    }

}
